import React from 'react';
import './PDPInstaPosts.scss';

import 'theme/vendor/slick.min.scss';
import User1 from '../../../../static/assets/img/pdp/insta-posts/user1.png';
import User2 from '../../../../static/assets/img/pdp/insta-posts/user2.png';
import User3 from '../../../../static/assets/img/pdp/insta-posts/user3.png';
import User4 from '../../../../static/assets/img/pdp/insta-posts/user4.png';

import { useSelector } from 'react-redux';
import { v4 } from 'uuid';

const POSTS = [
  {
    img: User1,
    text: 'Thank you fans for letting me have a pair of new glasses. Buy glasses at OWNDAYS before 5/12 and get 0.5 yuan off for 1 fan 😍',
  },
  {
    img: User2,
    text: 'Wow, I just want to change to glasses with anti-blue light recently 👓!',
  },
  {
    img: User3,
    text: 'Good deals are meant to be shared!',
  },
  {
    img: User4,
    text: 'New glasses 😎 🕶',
  },
];

const ProductReview = () => {
  const dataLocale = useSelector(state => state.locale);
  const { PDP_INSTA_POSTS_TITLE } = dataLocale;

  return (
    <>
      <div className="pdp-insta-posts">
        <div className="main-content-wrapper">
          <div className="pdp-insta-posts__title od-font-bold">{PDP_INSTA_POSTS_TITLE}</div>
          <div className="pdp-insta-posts__slider-wrapper">
            {POSTS.map(slide => (
              <div key={v4()} className="pdp-insta-posts__slide-wrapper">
                <div key={v4()} className="pdp-insta-posts__slide">
                  <div
                    className="pdp-insta-posts__slide-image"
                    style={{ backgroundImage: `url(${slide.img})` }}
                  />

                  <div className="pdp-insta-posts__slide-text od-font-reg">{slide.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductReview;
